import { SourceStatus, SourceType } from "@gx/ts-contracts/services/database/models/public_pb";
import {
  CreateProjectRequest,
  CreateProjectSourcesRequest,
  UpdateProjectRequest,
} from "@gx/ts-contracts/services/ontology/api/project_pb";
import { ProjectMappingMethod } from "@gx/ts-contracts/services/project/resources/project_configuration/project_configuration_pb";

import type { CreateProjectFormStep } from "@/pages/projects/forms/create/types";

export enum CreateProjectFormActionType {
  SET_STEP = "SET_STEP",
  SET_SEARCH = "SET_SEARCH",
  SET_CREATE_PROJECT_REQUEST = "SET_CREATE_PROJECT_REQUEST",
  SET_UPDATE_PROJECT_REQUEST = "SET_UPDATE_PROJECT_REQUEST",
  SET_IS_LOADING = "SET_IS_LOADING",
  SET_IS_UPDATE_PROJECT_SUCCEEDED = "SET_IS_UPDATE_PROJECT_SUCCEEDED",
  SET_CREATE_PROJECT_SOURCES_REQUEST = "SET_CREATE_PROJECT_SOURCES_REQUEST",
  SET_SHOULD_SHOW_ERRORS = "SET_SHOULD_SHOW_ERRORS",
  SET_SELECTED_STATUSES = "SET_SELECTED_STATUSES",
  SET_SELECTED_SOURCE_TYPES = "SET_SELECTED_SOURCE_TYPES",
  SET_SELECTED_MAPPING_METHOD = "SET_SELECTED_MAPPING_METHOD",
  SET_AUTO_INTROSPECT_PROMPT = "SET_AUTO_INTROSPECT_PROMPT",
  SET_PROJECT_SYNC_CRON_EXPRESSION = "SET_PROJECT_SYNC_CRON_EXPRESSION",
}

export interface SetStepAction {
  type: CreateProjectFormActionType.SET_STEP;
  payload: CreateProjectFormStep;
}

export interface SetSearchAction {
  type: CreateProjectFormActionType.SET_SEARCH;
  payload: string;
}

export interface SetCreateProjectRequestAction {
  type: CreateProjectFormActionType.SET_CREATE_PROJECT_REQUEST;
  payload: CreateProjectRequest;
}
export interface SetUpdateProjectRequestAction {
  type: CreateProjectFormActionType.SET_UPDATE_PROJECT_REQUEST;
  payload: UpdateProjectRequest;
}

export interface SetIsLoadingAction {
  type: CreateProjectFormActionType.SET_IS_LOADING;
  payload: boolean;
}

export interface SetIsUpdateProjectSucceededAction {
  type: CreateProjectFormActionType.SET_IS_UPDATE_PROJECT_SUCCEEDED;
  payload: boolean;
}

export interface SetCreateProjectSourcesRequestAction {
  type: CreateProjectFormActionType.SET_CREATE_PROJECT_SOURCES_REQUEST;
  payload: CreateProjectSourcesRequest;
}

export interface SetShouldShowErrorsAction {
  type: CreateProjectFormActionType.SET_SHOULD_SHOW_ERRORS;
  payload: boolean;
}

export interface SetSelectedStatusesAction {
  type: CreateProjectFormActionType.SET_SELECTED_STATUSES;
  payload: SourceStatus[];
}

export interface SetSelectedSourceTypesAction {
  type: CreateProjectFormActionType.SET_SELECTED_SOURCE_TYPES;
  payload: SourceType[];
}

export interface SetSelectedMappingMethodAction {
  type: CreateProjectFormActionType.SET_SELECTED_MAPPING_METHOD;
  payload: ProjectMappingMethod;
}

export interface SetAutoIntrospectPromptAction {
  type: CreateProjectFormActionType.SET_AUTO_INTROSPECT_PROMPT;
  payload: string;
}

export interface SetProjectSyncCronExpressionAction {
  type: CreateProjectFormActionType.SET_PROJECT_SYNC_CRON_EXPRESSION;
  payload: string;
}

export type CreateProjectFormAction =
  | SetStepAction
  | SetSearchAction
  | SetCreateProjectRequestAction
  | SetUpdateProjectRequestAction
  | SetIsLoadingAction
  | SetIsUpdateProjectSucceededAction
  | SetCreateProjectSourcesRequestAction
  | SetShouldShowErrorsAction
  | SetSelectedStatusesAction
  | SetSelectedSourceTypesAction
  | SetSelectedMappingMethodAction
  | SetAutoIntrospectPromptAction
  | SetProjectSyncCronExpressionAction;
